import React from 'react';
import { Typography, Box, Chip } from '@mui/material';
import { getCurrentVersion } from '../utils/version';

interface VersionDisplayProps {
  variant?: 'text' | 'chip' | 'compact';
  showLabel?: boolean;
}

const VersionDisplay: React.FC<VersionDisplayProps> = ({ 
  variant = 'text', 
  showLabel = true 
}) => {
  const version = getCurrentVersion();

  if (variant === 'chip') {
    return (
      <Chip
        label={`v${version}`}
        size="medium"
        variant="filled"
        color="primary"
        sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}
      />
    );
  }

  if (variant === 'compact') {
    return (
      <Typography variant="body2" color="primary" fontWeight="medium">
        {showLabel ? `v${version}` : version}
      </Typography>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {showLabel && (
        <Typography variant="body2" color="text.secondary">
          Version:
        </Typography>
      )}
      <Typography variant="body2" fontWeight="medium">
        {version}
      </Typography>
    </Box>
  );
};

export default VersionDisplay;
